import React from "react";
import PropTypes from "prop-types";
import { Col, Row, Card, CardBody, CardText, CardTitle, Form } from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getClientsList } from "../../store/clients/actions";
import styled from "styled-components";
import ReactSelect from "react-select";

const statuses = [
  { label: "Active", value: 4 },
  { label: "Not active", value: -3 },
  { label: "New", value: 1 },
  { label: "Signing contract", value: 2 },
  { label: "integration", value: 3 },
  { label: "Deffered", value: -1 },
  { label: "On hold", value: -2 },
]

const ClientsList = props => {
  const [clients, setClients] = React.useState([]);
  const [showClients, setShowClients] = React.useState(false);
  const [selectedStatus, setSelectedStatus] = React.useState(statuses[0]);

  React.useEffect(() => {
    let dt = props.clients;
    dt["offers__is_rent"] = true;
    dt["status"] = 4;
    dt["page"] = 1;
    props.getClientsList(dt);

    return () => {
      setShowClients(false);
    }
  }, []);

  React.useEffect(() => {
    setClientsList(props.clients);
    setShowClients(true);
  }, [props.clients]);

  const handleSelectStatus = (item, status) => {
    let dt = props.clients;
    dt["offers__is_rent"] = true;
    dt["status"] = item.value;
    dt["page"] = 1;
    if (status === 'init') { dt["search"] = ''; }
    setSelectedStatus(item)
    props.getClientsList(dt);
  };

  const setClientsList = clients => {
    setClients([]);
    if (props.clients.results?.length > 0) {
      let cl = [];
      props.clients?.results.map(i => {
        cl.push({
          id: i.id,
          name: i.legal_name,
          email: i.email,
        });
      });
      setClients(cl);
    }
  };

  return (
    <React.Fragment>
      <StyledRow>
        <div className="col-12">
          <StyledCard>
            <CardBody
              style={{
                padding: "1.25rem 0",
              }}
            >
              <FilterContainer className="d-flex justify-content-between align-items-end">
                <div>
                  <Form className="row gy-2 gx-3 align-items-center">
                    <div className="col-sm-auto">
                      <span>{"Filter by"}:</span>
                    </div>
                    <div className="col-sm-auto">
                      <CustomSelect
                        defaultValue={statuses[0]}
                        value={selectedStatus}
                        onChange={handleSelectStatus}
                        options={
                          statuses.map(i => {
                            return {
                              label: i.label,
                              value: i.value,
                            };
                          }) || []
                        }
                        classNamePrefix="select2-selection"
                        // isLoading={this.props.loading}
                        required
                      />
                    </div>
                  </Form>
                </div>
              </FilterContainer>
            </CardBody>
          </StyledCard>
        </div>
      </StyledRow>

      <Row>
        {showClients && clients.length > 0 ?
          clients.map((item, key) => (
            <Col sm={12} lg={6} xl={4} key={key} className="fade-in-custom-animate-1s">
              <Link
                to={{
                  pathname: `/${props.pathname}/${item.id}`,
                  state: { client_name: item.name },
                }}
              >
                <CardStyled style={{ border: "1px solid rgba(0,0,0,0.1)" }}>
                  <Row
                    className="d-flex align-items-center"
                    style={{ height: 100 }}
                  >
                    <Col md={12}>
                      <CardBody
                        style={{
                          padding: "15px",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Row className="d-flex">
                          <CardTitle
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "flex",
                              alignItems: "end",
                            }}
                            className="h5"
                          >
                            {item.name}
                          </CardTitle>
                          <CardText
                            style={{
                              display: "flex",
                              alignItems: "start",
                            }}
                          >
                            {item.email || "Descriptions is empty..."}
                          </CardText>
                        </Row>
                        <StyledImage>
                          <i className="bx bx-user-pin" />
                        </StyledImage>
                      </CardBody>
                    </Col>
                  </Row>
                </CardStyled>
              </Link>
            </Col>
          )) : (
            <Row className="align-items-center text-center mt-4">
              <Col xs={12}>
                <i
                  className="dripicons-archive"
                  style={{ fontSize: "130px", opacity: "0.2" }}
                />
                <p style={{ opacity: "0.2" }}>
                  Oops, clients not find..
                </p>
              </Col>
            </Row>
          )}
      </Row>
    </React.Fragment>
  );
};

const CustomSelect = styled(ReactSelect)`
  min-width: 240px;
`;

const FilterContainer = styled.div`
  flex-wrap: wrap;
  gap: 20px;

  & > div {
    flex: 1 1 300px;
  }
`;

const StyledRow = styled.div`
  padding: 0;
  margin: 0;
  z-index: 4;
  position: sticky;
  top: 69px;
`;

const StyledCard = styled(Card)`
  box-shadow: none !important;
  background: #f8f8fb;
  border-radius: 0.1px;
`;

const StyledImage = styled.div`
  width: 50px;
  display: flex;
  align-items: center;
  vertical-align: middle;
  font-size: 45px;
`;

const CardStyled = styled(Card)`
  transition-duration: 0.5s;
  &:hover {
    transition-duration: 0.5s;
    cursor: pointer;
    -webkit-box-shadow: 5px 5px 15px 5px rgba(0, 0, 0, 0.19);
    box-shadow: 5px 5px 15px 5px rgba(0, 0, 0, 0.1);
  }
`;

ClientsList.defaultProps = { pathname: "" };

ClientsList.propTypes = {
  history: PropTypes.any,
  pathname: PropTypes.string,
  getClientsList: PropTypes.func.isRequired,
  clients: PropTypes.any.isRequired,
  loading: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  clients: state.Clients.data,
  loading: state.Clients.loading,
});

export default connect(mapStateToProps, {
  getClientsList,
})(ClientsList);
